export default __webpack_public_path__ + "static/media/searchicon.fda14025.png";